import React from "react";
import Customersettingsheader from "../../components/Customer/general/Customersettingsheader";

const CustomerSettingsMasterLayout = ({ children, screenName, centered = true }) => {
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            height: '100vh',
            overflow: 'hidden',
            backgroundColor: '#ffffff'
        }}>
            <Customersettingsheader screenName={screenName} centered={centered} />
            <div style={{
                flex: 1,
                overflow: 'auto',
                display: 'flex',
                flexDirection: 'column'
            }}>
                {children}
            </div>
        </div>
    );
};

export default CustomerSettingsMasterLayout;